import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const EyeOpenIcon = ({ stroke, ...props }: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();
  const strokeColor = stroke || theme.palette.action.active;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      {...props}
    >
      <circle cx={12} cy={12} r={2.7} stroke={strokeColor} strokeWidth={1.5} />
      <path
        stroke={strokeColor}
        strokeWidth={1.5}
        d="M20.365 12a8.704 8.704 0 0 0-16.73 0 8.704 8.704 0 0 0 16.73 0Z"
      />
    </svg>
  );
};
